var App = App || {};

App.WidgetFeatures = (function ($) {
    'use strict';

    const breakpoints = ["md", "sm", "xs"];

    function Init(selector) {

        if (selector.length) {

            const state = { mobile: null, splide: null };

            Links(selector);
            Toggles(selector, state);
            Layout(selector, state);

            $(window).on("resize", function () { Layout(selector, state); });
        }
    }

    function Links(selector) {

        selector.find(".widget-features-card-summary a").not("[target]").attr({
            "target": "_blank",
            "rel": "noopener noreferrer",
            "aria-describedby": `${selector.attr("id")}_NewWindow`
        });
    }

    function Toggles(selector, state) {

        selector.on("click", ".widget-features-card-toggle", function () {

            const index = $(this).closest(".widget-features-card").attr("data-fc-features-index");

            Activate(selector, index);

            if (state.splide) {
                state.splide.go(parseInt(index, 10));
            }
        });
    }

    function Layout(selector, state) {

        const mobile = breakpoints.includes(ZagBreakpoints.GetBreakpoint());

        if (state.mobile === mobile) {
            return;
        }

        state.mobile = mobile;

        if (mobile) {
            MobileEnter(selector, state);
        }
        else {
            MobileExit(selector, state);
        }
    }

    function MobileEnter(selector, state) {

        const list = selector.find(".widget-features-slider .splide__list");

        Items(selector).appendTo(list);

        const options = {
            type: 'slide',
            speed: 500,
            arrows: true,
            pagination: false,
            perMove: 1,
            perPage: 1,
            gap: '2rem',
            rewind: true,
            label: 'Features'
        };

        const splide = new Splide(selector.find(".widget-features-slider .splide")[0], options);

        splide.on("moved", function (index) {
            const card = $(splide.Components.Elements.slides[index]).find(".widget-features-card");
            Activate(selector, card.attr("data-fc-features-index"));
        });

        splide.mount({});

        state.splide = splide;
    }

    function MobileExit(selector, state) {

        if (state.splide) {
            state.splide.destroy(true);
            state.splide = null;

            selector.find(".widget-features-item").find("a, button").removeAttr("tabindex");
        }

        Items(selector).each(function () {
            const home = $(this).attr("data-fc-features-home");
            $(this).appendTo(selector.find(`.widget-features-list[data-fc-features-column="${home}"]`));
        });
    }

    function Items(selector) {

        return selector.find(".widget-features-item").sort(function (a, b) {
            return $(a).find(".widget-features-card").attr("data-fc-features-index") - $(b).find(".widget-features-card").attr("data-fc-features-index");
        });
    }

    function Activate(selector, index) {

        const card = selector.find(`.widget-features-card[data-fc-features-index="${index}"]`);

        if (!card.length || card.hasClass("active")) {
            return;
        }

        selector.find(".widget-features-item").removeClass("active");
        selector.find(".widget-features-card").removeClass("active");
        selector.find(".widget-features-card-toggle").attr("aria-pressed", "false");

        card.addClass("active").closest(".widget-features-item").addClass("active");
        card.find(".widget-features-card-toggle").attr("aria-pressed", "true");

        Image(selector, card.attr("data-fc-features-image"), card.attr("data-fc-features-alt"));
    }

    function Image(selector, url, alt) {

        const image = selector.find(".widget-features-image-item");

        if (!url || image.attr("src") === url) {
            return;
        }

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            image.stop(true, true).attr({ "src": url, "alt": alt || "" }).show();
            return;
        }

        image.stop(true, true).fadeOut(200, function () {
            $(this).attr({ "src": url, "alt": alt || "" }).fadeIn(200);
        });
    }

    return {
        Init: Init
    };

})(jQuery);
